import { render } from "./PopupTag.vue?vue&type=template&id=62ba208e&scoped=true"
import script from "./PopupTag.vue?vue&type=script&lang=js"
export * from "./PopupTag.vue?vue&type=script&lang=js"

import "./PopupTag.vue?vue&type=style&index=0&id=62ba208e&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62ba208e"]])

export default __exports__